import InitiativeDetail from '../../components/light/initiative/InitiativeDetail';

const initiative = {
  title: 'Vocational Skills & Economic Empowerment',
  category: 'Economic Empowerment',
  year: '2020',
  location: 'Lagos, Oyo & Kwara States',
  heroImage: '/light/assets/imgs/spob/initiative-6.jpg',
  need: {
    headline:
      'Youth unemployment and a lack of marketable trade skills leave millions of young Nigerians economically vulnerable.',
    body: "Nigeria's youth unemployment rate remains among the highest in sub-Saharan Africa. Many young people finish secondary school without practical skills that employers or the market demand. Without a clear path to income, young people are vulnerable to exploitation, poverty, and disillusionment. SPOB's Vocational Skills initiative targets this gap by equipping youth with trade competencies and tools to build sustainable livelihoods.",
  },
  approach: {
    headline:
      'SPOB runs structured vocational training cohorts and provides starter toolkit grants to help graduates launch micro-enterprises.',
    body: 'Cohorts of 20–30 trainees are enrolled in 3-month vocational programmes covering trades such as carpentry, tailoring, phone repair, catering, and hairdressing. Training is delivered by certified artisans and trade professionals in community workshop spaces. Upon completing their programme, graduates receive a SPOB certificate and a starter toolkit grant to purchase initial tools or materials. Alumni networks provide peer support and business referrals.',
  },
  stats: [
    { number: '1,200+', label: 'Youth Trained' },
    { number: '80%', label: 'Employment Rate Post-Training' },
    { number: '15', label: 'Trade Tracks Available' },
  ],
  next: {
    title: 'Health Awareness & Community Outreach',
    href: '/light/initiative-health',
  },
};

export default function InitiativeVocational() {
  return <InitiativeDetail initiative={initiative} />;
}
